import { render } from "./OptionBar.vue?vue&type=template&id=98c79584"
import script from "./OptionBar.vue?vue&type=script&lang=js"
export * from "./OptionBar.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__